import React from "react";
import * as PropTypes from "prop-types";
import { formatNumericCell } from "../../utilities";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import { withTranslation } from "react-i18next";
import { translateGridText } from "../../i18n";

const columnDefinitions = (t) => [
    {
        headerName: t("Region code"),
        field: "regionCode",
        width: 150,
        headerClass: "ag-left-aligned-header",
    },
    {
        headerName: t("Reference pop"),
        field: "referencePop",
        width: 150,
        headerClass: "ag-left-aligned-header",
    },
    {
        headerName: t("Service statistic type"),
        field: "serviceStatisticType",
        width: 200,
        headerClass: "ag-left-aligned-header",
    },
    {
        headerName: t("Year"),
        field: "startYear",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        width: 125,
        headerClass: "ag-left-aligned-header",
    },
    {
        headerName: t("EMU"),
        field: "emu",
        type: "numericColumn",
        filter: "agNumberColumnFilter",
        valueFormatter: (params) => formatNumericCell(params.value, 3),
        width: 125,
        headerClass: "ag-left-aligned-header",
    },
    {
        headerName: t("SD_EMU"),
        field: "sD_EMU",
        width: 125,
        headerClass: "ag-left-aligned-header",
    },
    {
        headerName: t("EMU_ROC"),
        field: "emU_ROC",
        width: 125,
        headerClass: "ag-left-aligned-header",
    },
    {
        headerName: t("SD_EMU_ROC"),
        field: "sD_EMU_ROC",
        width: 150,
        headerClass: "ag-left-aligned-header",
    },
    {
        headerName: t("Include?"),
        field: "included",
        width: 125,
        headerClass: "ag-left-aligned-header",
    },
];

const EmuDataTable = ({ t, ...rest }) => {
    const rowData = rest.data;
    const columnDefs = columnDefinitions(t);

    return (
        <div className="ag-theme-material">
            <AgGridReact
                domLayout="autoHeight"
                defaultColDef={{ sortable: true, filter: true }}
                pagination={true}
                paginationPageSize={10}
                suppressColumnVirtualisation={true}
                suppressCellFocus={true}
                overlayNoRowsTemplate="<span />"
                getLocaleText={translateGridText}
                rowData={rowData}
                columnDefs={columnDefs}
                rowHeight={30}
                // autoSizeStrategy={{ type: "fitCellContents" }}
                // onGridReady={(params) => params.columnApi.autoSizeAllColumns()}
            />
        </div>
    );
};

EmuDataTable.propTypes = {
    data: PropTypes.array,
};

EmuDataTable.defaultProps = {
    data: [],
};

export default withTranslation()(EmuDataTable);
